<template>
    <b-card header="Agency Overview">
        <div class="row block agency-details">
            <div
                class="col col-auto me-4"
                v-if="hasPermission('ViewAgencyDetails')">
                <div class="row">
                    <div class="col-auto text-left"><span class="h5">Address:</span></div>

                    <div
                        class="col-8 text-left"
                        v-if="data?.loc_street && data?.loc_town">
                        <div>
                            {{ data?.loc_street }}
                        </div>
                        <div>
                            {{ data?.loc_town }},
                            {{ data?.loc_state }}
                        </div>
                        <div>
                            {{ data?.loc_zip }}
                        </div>
                    </div>
                    <div
                        class="col-8 text-left"
                        v-else-if="data?.mail_street && data?.mail_town">
                        <div>
                            {{ data?.mail_street }}
                        </div>
                        <div>
                            {{ data?.mail_town }},
                            {{ data?.mail_state }}
                        </div>
                        <div>
                            {{ data?.mail_zip }}
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="population?.year > 0"
                class="col col-auto me-4">
                <span class="h5">{{ population?.year }} Population:</span>

                {{ formatNumber(population?.employee_population) }}
            </div>

            <div class="col col-auto staffing me-4">
                <div v-if="staffing">
                    <div class="row">
                        <div
                            class="col-12 text-left"
                            v-if="staffing.year > 0">
                            <span class="h5 w-100">{{ staffing.year }} Employee Count</span>
                        </div>
                    </div>
                    <div v-if="staffing.sworn_in_male">
                        <span class="h5">Sworn-in Male:</span>
                        {{ formatNumber(staffing.sworn_in_male) }}
                    </div>
                    <div v-if="staffing.sworn_in_female">
                        <span class="h5">Sworn-in Female:</span>
                        {{ formatNumber(staffing.sworn_in_female) }}
                    </div>
                    <div v-if="staffing.civilian_male">
                        <span class="h5">Civilian Male:</span>
                        {{ formatNumber(staffing.civilian_male) }}
                    </div>
                    <div v-if="staffing.civilian_female">
                        <span class="h5">Civilian Female:</span>
                        {{ formatNumber(staffing.civilian_female) }}
                    </div>
                </div>
            </div>
        </div>
    </b-card>

    <b-card
        header="Agency Contacts"
        v-if="hasPermission('ViewAgencyContacts') && hasContacts">
        <div class="row block contacts">
            <agency-overview-contact
                :title="data?.admin_title"
                :name="data?.admin_name"
                :email="data?.admin_email"
                :phone="data?.admin_phone"
                :fax="data?.admin_fax" />
            <agency-overview-contact
                :title="data?.ucr_title"
                :name="data?.ucr_name"
                :email="data?.ucr_email"
                :phone="data?.ucr_phone"
                :fax="data?.ucr_fax" />
            <agency-overview-contact
                :title="data?.comm_title"
                :name="data?.comm_name"
                :email="data?.comm_email"
                :phone="data?.comm_phone"
                :fax="data?.comm_fax" />
        </div>
    </b-card>
</template>
<script setup lang="ts">
import {BCard} from "./../Misc";
import {formatNumber} from "@/utils";
import AgencyOverviewContact from "./AgencyOverviewContact.vue";
const props = defineProps({
    ori: {
        type: String,
        default: null,
    },
});

import {computed, watch} from "vue";
import {useOriStore} from "@/stores/oriStore";
import hasPermission from "@/composable/permissionHelper";
import {storeToRefs} from "pinia";

const oriStore = useOriStore();
var {population, staffing} = storeToRefs(useOriStore());

const data = computed(() => {
    return oriStore.ori;
});

const hasContacts = computed(() => {
    return data.value?.admin_name || data.value?.ucr_name || data.value?.comm_name;
});

watch(props, async () => {
    await oriStore.getPopulation(props.ori);
    await oriStore.getStaffing(props.ori);
});
</script>
<style lang="scss">
dt {
    float: left;
    clear: left;
    padding-right: 5px;
    font-weight: bold;
}

dd {
    margin-left: 0px;
}
.agency-details {
    .staffing {
        span {
            &.h5 {
                display: inline-block;
                width: 110px;
            }
        }
    }
}
.contacts {
    span {
        &.h5 {
            display: inline-block;
            width: 45px;
        }
    }
}
</style>
